import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import AboutPage from './views/AboutPage.vue'
import GreetingPrinciple from './views/GreatingPrinciple.vue'
import Contact from './views/Contact.vue'
import BlogPage from './views/BlogPage'
import BlogDetail from './views/BlogDetail'
import GuidePage from './views/GuidePage.vue'
import studentMessages from './views/StudentMessages.vue'
import GalleryBook from './views/GalleryBook.vue'
import CourseDetail from './views/CourseDetail.vue'
import BeginnerCourse from './views/BeginnerCourse.vue'
import ElementaryCourse from './views/ElementaryCourse.vue'
import IntermediateCourse from './views/IntermediateCourse.vue'
import UpperIntermediateCourse from './views/UpperIntermediateCourse.vue'
import NotFound from './views/404.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/school-history',
            name: 'about',
            component: AboutPage
        },
        {
            path: '/greeting-of-principle',
            name: 'greeting_of_principle',
            component: GreetingPrinciple
        },
        {
            path: '/contact',
            name: 'contact',
            component: Contact
        },
        {
            path: '/blogs',
            name: 'blogs',
            component: BlogPage
        },
        {
            path: '/blog/:id',
            name: 'BlogDetail',
            component: BlogDetail,
            props: true,
        },
        {
            path: '/school-and-career-guidance',
            name: 'schoolAndCareerGuidance',
            component: GuidePage
        },
        {
            path: '/student-messages',
            name: 'studentMessages',
            component: studentMessages
        },
        {
            path: '/gallery-book',
            name: 'galleryBook',
            component: GalleryBook
        },
        {
            path: '/course/:id',
            name: 'courseDetail',
            component: CourseDetail,
            props: true
        },
        {
            path: '/beginner-course',
            name: 'beginnerCourse',
            component: BeginnerCourse
        },
        {
            path: '/elementary-course',
            name: 'elementaryCourse',
            component: ElementaryCourse
        },
        {
            path: '/intermediate-course',
            name: 'intermediateCourse',
            component: IntermediateCourse
        },
        {
            path: '/upper-intermediate-course',
            name: 'upperIntermediateCourse',
            component: UpperIntermediateCourse
        },
        {
            path: '*', // This is the catch-all route
            name: 'not-found',
            component: NotFound
        }
    ]
})